import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
  ActualizaConcepto, ActualizaEstadosContenido, ActualizaEstadosSolicitud, ContabilidadContenido, ContenidoSolicitud,
  DetalleSolicitud, DevolucionSinPrestamo, FechaContenidos, FiltrosContenidos, HistoricoServicio, SituacionContenido, SituacionSolicitud
} from '../../model/detalle-solicitud';
import { IPagination } from '../../model/pagination';
import { SolicitudMaterial } from '../../model/solicitud-materiales';


@Injectable()
export class DetalleService {
  idsolicitud: number;

  PATH_HISTO = '';
  PATH_CONTENT = '';
  PATH_DEVOLUCIONES = '';
  PATH_SERVICES = '';
  PATH_CONTA = '';
  PATH_MATERIALS = '';
  PATH_HISTOURGORI = '';
  PATH_HISTOPROVEE = '';
  PATH_ESTADOS = '';
  PATH_PROVEEDORES = '';
  constructor(private http: HttpClient) {
    this.PATH_HISTO = environment.API_BASE + '/Trazas/Estados';
    this.PATH_CONTENT = environment.API_BASE + '/Series/Values';
    this.PATH_SERVICES = environment.API_BASE + '/Services';
    this.PATH_CONTA = environment.API_BASE + '/Contabilidad';
    this.PATH_MATERIALS = environment.API_BASE + '/Materials';
    this.PATH_DEVOLUCIONES = environment.API_BASE + '/Series/Prestamos';
    this.PATH_HISTOURGORI = environment.API_BASE + '/Trazas/EstadosUrgOri';
    this.PATH_HISTOPROVEE = environment.API_BASE + '/Trazas/Proveedores';
    this.PATH_ESTADOS = environment.API_BASE + '/Estado';

    this.PATH_PROVEEDORES = environment.API_BASE + '/Proveedores';
    // /Contabilidad/{IdContenido}/{TipoServicio}/{IdClient}

  }

  getRequestedMaterials(solicitudId: number): Observable<SolicitudMaterial[]> {
    return this.http.get<any[]>(this.PATH_MATERIALS + '/Request/' + solicitudId)
      .pipe(map((response: SolicitudMaterial[]) => {
        if (typeof response == 'string') {
          return null;
        }
        return response.map(respon => SolicitudMaterial.toModel(JSON.stringify(respon)));
      }));
  }


  getContabilidadContenido(idcontenido: number, tiposervicio: number, idcliente: number): Observable<ContabilidadContenido[]> {
    return this.http.get<ContabilidadContenido[]>(this.PATH_CONTA + '/' + idcontenido + '/' + tiposervicio + '/' + idcliente)
      .pipe(map((result) =>
        result.map((contabilidadContenido) => ContabilidadContenido.toModel(JSON.stringify(contabilidadContenido)))));
  }


  getHistorico(solicitudId: number): Observable<HistoricoServicio[]> {
    return this.http.get<HistoricoServicio[]>(this.PATH_HISTO + '/' + solicitudId);
  }

  getAllContent(solicitudId: number): Observable<ContenidoSolicitud[]> {
    return this.http.get<ContenidoSolicitud[]>(this.PATH_CONTENT + '/' + solicitudId);
  }

  getContentNoInventory(solicitudId: number, filtro: FiltrosContenidos, slice: number, take: number): Observable<IPagination<ContenidoSolicitud>> {
    const observable = this.http.post<any>(this.PATH_CONTENT + '/SerieDocumentalInterna/' + solicitudId + '/' + slice + '/' + take, filtro)
      .pipe(map((paginationContenidoSolicitudList: IPagination<ContenidoSolicitud>) =>
        IPagination.toModel<ContenidoSolicitud>(JSON.stringify(paginationContenidoSolicitudList), ContenidoSolicitud)));
    return observable as Observable<IPagination<ContenidoSolicitud>>;
  }

  getDevolucionesNoInventory(filtro: FiltrosContenidos, slice: number, take: number): Observable<IPagination<ContenidoSolicitud>> {
    const observable = this.http.post<any>(this.PATH_DEVOLUCIONES + '/SerieDocumentalInterna/' + slice + '/' + take, filtro)
      .pipe(map((paginationContenidoSolicitudList: IPagination<ContenidoSolicitud>) =>
        IPagination.toModel<ContenidoSolicitud>(JSON.stringify(paginationContenidoSolicitudList), ContenidoSolicitud)));
    return observable as Observable<IPagination<ContenidoSolicitud>>;
  }

  getContentRecord(solicitudId: number, filtro: FiltrosContenidos, slice: number, take: number): Observable<IPagination<ContenidoSolicitud>> {
    const observable = this.http.post<any>(this.PATH_CONTENT + '/Expedientes/' + solicitudId + '/' + slice + '/' + take, filtro)
      .pipe(map((paginationContenidoSolicitudList: IPagination<ContenidoSolicitud>) =>
        IPagination.toModel<ContenidoSolicitud>(JSON.stringify(paginationContenidoSolicitudList), ContenidoSolicitud)));
    return observable as Observable<IPagination<ContenidoSolicitud>>;
  }

  getDevolucionesRecord(filtro: FiltrosContenidos, slice: number, take: number): Observable<IPagination<ContenidoSolicitud>> {
    const observable = this.http.post<any>(this.PATH_DEVOLUCIONES + '/Expedientes/' + slice + '/' + take, filtro)
      .pipe(map((paginationContenidoSolicitudList: IPagination<ContenidoSolicitud>) =>
        IPagination.toModel<ContenidoSolicitud>(JSON.stringify(paginationContenidoSolicitudList), ContenidoSolicitud)));
    return observable as Observable<IPagination<ContenidoSolicitud>>;
  }

  getContentContainer(solicitudId: number, filtro: FiltrosContenidos, slice: number, take: number): Observable<IPagination<ContenidoSolicitud>> {
    const observable = this.http.post<any>(this.PATH_CONTENT + '/Contenedores/' + solicitudId + '/' + slice + '/' + take, filtro)
      .pipe(map((paginationContenidoSolicitudList: IPagination<ContenidoSolicitud>) =>
        IPagination.toModel<ContenidoSolicitud>(JSON.stringify(paginationContenidoSolicitudList), ContenidoSolicitud)));
    return observable as Observable<IPagination<ContenidoSolicitud>>;
  }

  getDevolucionesContainer(filtro: FiltrosContenidos, slice: number, take: number): Observable<IPagination<ContenidoSolicitud>> {
    const observable = this.http.post<any>(this.PATH_DEVOLUCIONES + '/Contenedores/' + slice + '/' + take, filtro)
      .pipe(map((paginationContenidoSolicitudList: IPagination<ContenidoSolicitud>) =>
        IPagination.toModel<ContenidoSolicitud>(JSON.stringify(paginationContenidoSolicitudList), ContenidoSolicitud)));
    return observable as Observable<IPagination<ContenidoSolicitud>>;
  }

  getContentAZ(solicitudId: number, filtro: FiltrosContenidos, slice: number, take: number): Observable<IPagination<ContenidoSolicitud>> {
    const observable = this.http.post<any>(this.PATH_CONTENT + '/AZ/' + solicitudId + '/' + slice + '/' + take, filtro)
      .pipe(map((paginationContenidoSolicitudList: IPagination<ContenidoSolicitud>) =>
        IPagination.toModel<ContenidoSolicitud>(JSON.stringify(paginationContenidoSolicitudList), ContenidoSolicitud)));
    return observable as Observable<IPagination<ContenidoSolicitud>>;
  }

  getDevolucionesAZ(filtro: FiltrosContenidos, slice: number, take: number): Observable<IPagination<ContenidoSolicitud>> {
    const observable = this.http.post<any>(this.PATH_DEVOLUCIONES + '/AZ/' + slice + '/' + take, filtro)
      .pipe(map((paginationContenidoSolicitudList: IPagination<ContenidoSolicitud>) =>
        IPagination.toModel<ContenidoSolicitud>(JSON.stringify(paginationContenidoSolicitudList), ContenidoSolicitud)));
    return observable as Observable<IPagination<ContenidoSolicitud>>;
  }

  getViewDetails(solicitudId: number): Observable<DetalleSolicitud> {
    return this.http.get<DetalleSolicitud>(this.PATH_SERVICES + '/' + solicitudId);
  }

  hasMulticlientPermissions(solicitudId: number): Observable<string> {
    return this.http.get<string>(this.PATH_SERVICES + '/MulticlientPermission/' + solicitudId);
  }

  getCanReturnWithoutLoan(): Observable<DevolucionSinPrestamo> {
    return this.http.get(this.PATH_SERVICES + '/DevolucionSinPrestamo')
      .pipe(map((result) => DevolucionSinPrestamo.toModel(JSON.stringify(result))));
  }


  getSituacionesByService(idservicio: number): Observable<SituacionSolicitud[]> {
    return this.http.get<SituacionSolicitud[]>
      (this.PATH_SERVICES + '/GetSituationServicio' + '/' + idservicio);
  }

  getSituacionesContenidoByService(idservicio: number): Observable<SituacionContenido[]> {
    return this.http.get<SituacionContenido[]>(this.PATH_SERVICES + '/GetSituationContenido' + '/' + idservicio);
  }


  updateConcepto(concepto: ActualizaConcepto[]): Observable<any> {
    return this.http.post(this.PATH_CONTA, concepto, { observe: 'response' });
  }
  /*Services/Situation/Contenido
  Este servicio modifica el estado y la situación de un contenido. Si el estado que pones es de finalización rellena la fecha de finalización.

  Services/Situation/Servicio
  Este servicio modifica el estado y la situación de un servicio. Si el estado que pones es de finalización rellena la fecha de finalización.
  */

  getHistoricoUrgOri(solicitudId: number): Observable<HistoricoUrgOriServicio[]> {
    return this.http.get<HistoricoUrgOriServicio[]>(this.PATH_HISTOURGORI + '/' + solicitudId);
  }

  getHistoricoProveedor(solicitudId: number): Observable<HistoricoProveedorServicio[]> {
    return this.http.get<HistoricoProveedorServicio[]>(this.PATH_HISTOPROVEE + '/' + solicitudId);
  }

  updateEstadosContenido(estado: ActualizaEstadosContenido[]): Observable<any> {
    return this.http.post(this.PATH_SERVICES + '/Situation/Contenido', estado, { observe: 'response' });
  }

  updateEstadosSolicitud(estado: ActualizaEstadosSolicitud): Observable<any> {
    return this.http.post(this.PATH_SERVICES + '/Situation/Servicio', estado, { observe: 'response' });
  }

  updateFechaSLA(fechasla: any) {
    return this.http.post(this.PATH_SERVICES + '/SLA', fechasla, { observe: 'response' });
  }

  updateFechaEntradaContenidos(fechaContenidos: FechaContenidos) {
    return this.http.post(this.PATH_SERVICES + '/EntryDate', fechaContenidos, { observe: 'response' });
  }

  updateFechaRealFinalizacionContenidos(fechaContenidos: FechaContenidos) {
    return this.http.post(this.PATH_SERVICES + '/RealEndDate', fechaContenidos, { observe: 'response' });
  }

  updateFechaExpiracionContenidos(fechaContenidos: FechaContenidos) {
    return this.http.post(this.PATH_SERVICES + '/ExpirationDate', fechaContenidos, { observe: 'response' });
  }


  finalizeRequestAndAllContents(requestId: number,
    stateRequestId: number,
    situationRequestId: number,
    stateContentId: number,
    situationContentId: number): Observable<any> {
    const object = {
      ID_SOLICITUD_SERVICIO: requestId,
      ID_ESTADO: stateRequestId,
      ID_SITUACION: situationRequestId,
      ID_ESTADO_CONTENIDOS: stateContentId,
      ID_SITUACION_CONTENIDOS: situationContentId
    };
    return this.http.post(this.PATH_SERVICES + '/Situation/Finalize', object);
  }

}

export class HistoricoUrgOriServicio {
  USUARIO: string;
  NOMBREYAPES: string;
  FECHA: Date;
  ESTADO_INICIAL: string;
  ESTADO_FINAL: string;
  constructor() { }
}

export class HistoricoProveedorServicio {
  USUARIO: string;
  ID_SOLICITUD: number;
  FECHA: Date;
  PROVEEDOR_FINAL: string;
  PROVEEDOR_INCIAL: string;
  ID_CONTENIDO: string;
  constructor() { }
}
